var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar_view"},[_c('ul',_vm._l((_vm.barList),function(item,index){return _c('li',{key:index,class:_vm.active == index ? 'blue' : ''},[_c('span',[_vm._v(_vm._s(index + 1)+"、")]),_c('p',[_vm._v(" "+_vm._s(item.lable)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }